import React, { useState } from 'react';
import { makeStyles, Popover, Button } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ArrowDropDownOutlinedIcon from '@material-ui/icons/ArrowDropDownOutlined';
import moment from 'moment';
import { useField } from 'react-final-form';
import MomentUtils from '@date-io/moment';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: theme.spacing(2),
  },
  popover: {
    '& .MuiToolbar-root': {
      display: 'none',
    },
  },
  dateButton: {
    border: 'none',
    textTransform: 'none',
    padding: '2px 2px 2px 8px',
    '&:hover': {
      border: 'none',
    },
  },
  error: {
    color: theme.palette.error.main,
  },
}));

const DateInputField = (props) => {
  const { label, name, validate, pickerProps } = props;

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const {
    input: { value, onChange },
    meta: { touched, error },
  } = useField(name, { validate });

  const handleChange = (newValue) => {
    onChange(newValue ? moment(newValue) : null);
    handleClose();
  };

  return (
    <>
      <Popover
        className={classes.popover}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <DatePicker
            className={classes.input}
            autoOk
            clearable
            views={['month', 'date']}
            value={value ? value : null}
            onChange={handleChange}
            open={!!anchorEl}
            variant={'static'}
            {...pickerProps}
          />
        </MuiPickersUtilsProvider>
      </Popover>

      <Button
        onClick={handleOpen}
        color="primary"
        variant="outlined"
        className={classNames(classes.dateButton, touched && !!error && classes.error)}>
        {value ? value.format('LL') : label}
        <ArrowDropDownOutlinedIcon />
      </Button>
    </>
  );
};

export default DateInputField;
